import React, { useEffect } from 'react'
import { isClient } from '../../../helpers'
import { ChrComponent, ChrGlobal } from '../../../types'
import { withParsedContext } from '../../Magazines/withJSSContext'

interface Props {
  parsedFields: {
    footerModel: ChrComponent
    footerAssetsUrl: string
    footerCssUrl: string
  }

  parsedSitecoreContext: {
    'Discovery.Feature.FeIntegration.IntegrationData'?: ChrGlobal
  }
}

const FooterZoneV2: React.FC<Props> = ({ parsedFields, parsedSitecoreContext }) => {
  const footerData = parsedFields.footerModel
  const footerAnalyticsModel = parsedSitecoreContext['Discovery.Feature.FeIntegration.IntegrationData']
  const assetsUrl = parsedFields.footerAssetsUrl

  if (isClient) {
    window.chrGlobal = footerAnalyticsModel || {}
  }

  useEffect(() => {
    const host = document.getElementById('footerHost')
    if (!host) return

    const shadowRoot = host.attachShadow({ mode: 'open' })

    const linkEl = document.createElement('link')
    linkEl.rel = 'stylesheet'
    linkEl.href = parsedFields.footerCssUrl
    shadowRoot.appendChild(linkEl)

    const styleEl = document.createElement('style')
    styleEl.textContent = `
      :root, :host(#headerHost), :host(#footerHost) {
        --z-index-base: 100;
      }
    `
    shadowRoot.appendChild(styleEl)

    const footerRootEl = document.createElement('div')
    footerRootEl.id = 'footerRoot'
    shadowRoot.appendChild(footerRootEl)

    const footerScriptEl = document.createElement('script')
    footerScriptEl.type = 'module'
    footerScriptEl.textContent = `
      import ReactTools, { Footer } from "${assetsUrl}";

      // Access shadow DOM elements
      const hostEl = document.getElementById("footerHost");
      const shadowRoot = hostEl.shadowRoot;
      const footerRootEl = shadowRoot.getElementById("footerRoot");

      if (footerRootEl) {
        const footerRoot = ReactTools.createRoot(footerRootEl);
        footerRoot.render(
          ReactTools.createElement(Footer, {
            footerData: ${JSON.stringify(footerData)},
          })
        );
      }
    `

    document.body.appendChild(footerScriptEl)

    return (): void => {
      if (document.body.contains(footerScriptEl)) {
        document.body.removeChild(footerScriptEl)
      }
    }
  }, [])

  return (
    <div>
      <div id="footerHost" />
      <button id="cookie-settings-shadow-dom" className="ot-sdk-show-settings" style={{ display: 'none' }}></button>
    </div>
  )
}

export default withParsedContext(FooterZoneV2 as React.FC)
